let specifierTypesData = [];
export default class SpecifierTypesCache {
    setSpecifierTypes(data) {
        specifierTypesData = data;
    }
    getSpecifierTypes() {
        return specifierTypesData;
    }
}
